/* eslint-disable */
export default {
  en: '英語',
  ja: '日本語',
  fr: 'フランス語',
  de: 'ドイツ語',
  es: 'スペイン語',
  it: 'イタリア語',
  pt: 'ポルトガル語',
  zh: '中国語',
  nl: 'オランダ語',
  ko: '韓国語',
  fi: 'フィンランド語',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
